import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { NetworkCallService } from '../../../../../src/app/core/services/network-call.service';
import * as authActions from '../actions';
import { IBusinessUserRolesRequest, IBusinessUserRolesResponse } from '../models/business-user-roles.model';
import { HelpersService } from '../../../core/services/helpers.service';
import { SessionStorageIds } from '../../../shared/enums';

@Injectable()
export class BusinessUserRoleEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private helperService: HelpersService
  ) {}

  getBusinessUserRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.loadBusinessUserRoles), // Listen for the fetch action
      switchMap(action => {
        const cachedData = sessionStorage.getItem(SessionStorageIds.PERMISSIONS);
        if (cachedData) {
          return of(authActions.loadBusinessUserRolesSuccess({
            response: JSON.parse(cachedData)
          }));
        } else {
          return this.networkCallService
          .post<IBusinessUserRolesRequest, IBusinessUserRolesResponse>('Authentication/businessUserRoles', action.request).pipe(
            map((data) => {
              sessionStorage.setItem(SessionStorageIds.PERMISSIONS, JSON.stringify(data));
              return authActions.loadBusinessUserRolesSuccess({
                response: data
              });
            }),
            catchError((error) => {
              return of(authActions.loadBusinessUserRolesFailure(error));
            })
          );
        }
      })
    )
  );
}
